(function () {

    'use strict';

    angular.module('iplusjs.alert.service', [
        'lodash',
        'iplusjs.utils.misc',
        'iplusjs.utils.device',
        'iplusjs.utils.html',
        'iplusjs.navigation'
    ])
        .service('AlertService', AlertService);

    AlertService.$inject = [
        '$rootScope',
        '$injector',
        '$sce',
        '$anchorScroll',
        '$timeout',
        'lodash',
        'MiscUtilsService'
    ];
    function AlertService($rootScope, $injector, $sce, $anchorScroll, $timeout, _, MiscUtilsService) {
        var that = this,
            alerts = [];

        that.stateActions = {};
        $rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams) {
            if (!toState || toState.parent !== 'fehler') {
                clear();
            }
        });

        $rootScope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState, fromParams) {
            fromState = fromState || {
                'abstract': false
            };

            if ((!toState || toState.parent !== 'fehler') && !fromState.abstract && _.get(fromState, 'data.clearAlerts') !== false) {
                clear();
            }
            $timeout(function () {
                add(toParams.alerts);
            });
        });

        $rootScope.$on('iplusjs:addAlert', function (event, alert) {
            add(alert);
        });

        $rootScope.$on('iplusjs:createAndAddAlert', function (event, alert) {
            if (!alert || !_.isObject(alert)) {
                return;
            }
            add(create(alert.message, alert.type, alert.permanent, alert.id, alert.timeout, alert.reason, alert.compareField));
        });

        $rootScope.$on('iplusjs:removeAlert', function (event, alert) {
            remove(alert);
        });

        $rootScope.$on('iplusjs:removeAlerts', function (event, alerts) {
            remove(alerts);
        });

        $rootScope.$on('iplusjs:removeAllAlerts', function (event) {
            clear(true);
        });

        that.setStateActions = setStateActions;
        that.create = create;
        that.get = get;
        that.add = add;
        that.remove = remove;
        that.removeByIndex = removeByIndex;
        that.removeById = removeById;
        that.removeByType = removeByType;
        that.removeByReason = removeByReason;
        that.clear = clear;
        that.exists = exists;
        that.hasAlerts = hasAlerts;
        that.getSteps = getSteps;
        that.removeSteps = removeSteps;
        function setStateActions(stateActions) {
            that.stateActions = stateActions;
        }
        function create(message, type, permanent, id, timeout, reason, compareField) {
            var NavigationService = $injector.get('NavigationService'),
                step = {};

            if (id && that.stateActions && that.stateActions[id]) {
                step = NavigationService.get(that.stateActions[id]);

            }

            return {
                message: $sce.trustAsHtml(message),
                type: _.toLower(type),
                permanent: !!permanent,
                id: id,
                step: !step.disabled && !step.hidden ? step : {},
                _compareField: compareField || (message + type),
                timeout: timeout,
                reason: reason
            };
        }
        function get() {
            return alerts;
        }
        function add() {
            var alert = arguments[0],
                NavigationService,
                steps;

            if (_.isArray(alert)) {
                _.forEach(alert, function (obj) {
                    if (obj && !exists('_compareField', _.get(obj, '_compareField')) && MiscUtilsService.isNotEmpty(obj.message)) {
                        alerts.push(obj);
                    }
                });
            } else if (_.isObject(alert)) {
                if (!exists('_compareField', _.get(alert, '_compareField')) && MiscUtilsService.isNotEmpty(alert.message)) {
                    alerts.push(alert);
                }
            } else if (MiscUtilsService.isNotEmpty(arguments[0])) {
                alerts.push(create(arguments[0], arguments[1], arguments[2], arguments[3], arguments[4]));
            }

            steps = getSteps();

            if (steps.length === 1) {
                NavigationService = $injector.get('NavigationService');
                removeSteps(steps[0].name);
                NavigationService.goToStep(steps[0].name, {
                    alerts: alerts
                });
            }

            if (hasAlerts()) {
                $anchorScroll('anchorGlobalAlert');
            }
        }

        function remove(alerts) {
            if (MiscUtilsService.isEmpty(alerts)) {
                return;
            }

            if (_.isArray(alerts)) {
                _.each(alerts, function (alert) {
                    _remove(alert);
                });
            } else {
                _remove(alerts);
            }
        }

        function _remove(alert) {
            if (alert.id) {
                removeById(alert.id);
            } else if (alert.index) {
                removeByIndex(alert.index);
            } else if (alert.type) {
                removeByType(alert.type);
            } else if (alert.reason) {
                removeByReason(alert.reason);
            }
        }
        function removeByIndex(index) {
            alerts.splice(index, 1);
        }
        function removeById(id) {
            var idx,
                alertsToRemove = [];

            if (_.isRegExp(id)) {
                _.forEach(alerts, function (alert) {
                    if (id.test(alert.id)) {
                        alertsToRemove.push(alert);
                    }
                });

                remove(alertsToRemove);
            } else {
                idx = _.findIndex(alerts, {
                    id: id
                });

                if (idx !== -1) {
                    removeByIndex(idx);
                }
            }
        }
        function removeByType(type) {
            _.remove(alerts, function (alert) {
                return alert.type === type;
            });
        }
        function removeByReason(reason) {
            _.remove(alerts, function (alert) {
                return alert.reason === reason;
            });
        }
        function clear(permanent) {
            if (hasAlerts()) {
                if (permanent) {
                    alerts = [];
                } else {
                    alerts = _.filter(alerts, {
                        permanent: !permanent // Alle außer die permanenten löschen
                    });
                }
            }
        }
        function exists(findProp, findVal) {
            findProp = findProp || '_compareField';
            return _.findIndex(alerts, [findProp, findVal]) > -1;
        }
        function hasAlerts() {
            return !!(alerts && alerts.length);
        }
        function getSteps() {
            var steps = [];

            _.forEach(alerts, function (alert) {
                if (MiscUtilsService.isNotEmpty(alert.step)) {
                    steps.push(alert.step);
                }
            });

            return steps;
        }
        function removeSteps(stepName) {
            _.forEach(alerts, function (alert) {
                if (MiscUtilsService.isNotEmpty(alert.step)) {
                    if (alert.step.name === stepName || MiscUtilsService.isEmpty(stepName)) {
                        alert.step = {};
                    }
                }
            });
        }

    }
})();
